import { CoreMenu } from '@core/types';

// AOS DEVS: LEMBREM-SE SEMPRE DE MANTER O MENU EM ORDEM ALFABÉTICA!!!!!!!!!!!!!!!

export function getMenu(): CoreMenu[] {
  return [
    {
      id: 'dashboard',
      title: 'Home',
      type: 'item',
      icon: 'home',
      url: '/home',
    },
    {
      id: 'administrativo',
      title: 'Administrativo',
      type: 'collapsible',
      icon: 'edit',
      children: [
        {
          id: 'inventario',
          title: 'Inventário',
          type: 'item',
          icon: '',
          url: '/inventario',
        },
        {
          id: 'budget',
          title: 'Budget',
          type: 'item',
          icon: '',
          url: '/budget',
        },
        {
          id: 'categorias_financeiras',
          title: 'Categoria Financeira',
          type: 'item',
          icon: '',
          url: '/categoria-financeira',
        },
        {
          id: 'centro_de_custo',
          title: 'Centro de Custo',
          type: 'item',
          icon: '',
          url: '/centro-custo',
        },
        {
          id: 'conta_contabil',
          title: 'Conta Contábil',
          type: 'item',
          icon: '',
          url: '/conta-contabil',
        },
        {
          id: 'despesa',
          title: 'Despesas',
          type: 'item',
          icon: '',
          url: '/despesa',
        },
      ],
    },
    {
      id: 'cadastro',
      title: 'Cadastro',
      type: 'collapsible',
      icon: 'file-text',
      children: [
        {
          id: 'bancos',
          title: 'Bancos',
          type: 'item',
          icon: '',
          url: '/banco',
        },
        {
          id: 'calendario',
          title: 'Calendário',
          type: 'item',
          icon: '',
          url: '/calendario',
        },
        {
          id: 'carrocerias_de_veiculos',
          title: 'Carrocerias de Veículos',
          type: 'item',
          icon: '',
          url: '/carrocerias-veiculos',
        },
        {
          id: 'cfop',
          title: 'CFOP',
          type: 'item',
          icon: '',
          url: '/cfop',
        },
        {
          id: 'cst',
          title: 'CST',
          type: 'item',
          icon: '',
          url: '/cst',
        },
        {
          id: 'configuracao_imposto',
          title: 'Configurações de Impostos',
          type: 'item',
          icon: '',
          url: '/configuracao-imposto',
        },
        {
          id: 'cidade',
          title: 'Cidade',
          type: 'item',
          icon: '',
          url: '/cidade',
        },
        {
          id: 'custo_item_financeiro',
          title: 'Custos Financeiros',
          type: 'item',
          icon: '',
          url: '/custoFinanceiro',
        },
        {
          id: 'embalagens',
          title: 'Embalagens',
          type: 'item',
          icon: '',
          url: '/embalagem',
        },
        {
          id: 'empresa',
          title: 'Empresas',
          type: 'item',
          icon: '',
          url: '/empresa',
        },
        {
          id: 'estado',
          title: 'Estado',
          type: 'item',
          icon: '',
          url: '/estado',
        },
        {
          id: 'familia',
          title: 'Família',
          type: 'item',
          icon: '',
          url: '/familia',
        },
        {
          id: 'filial',
          title: 'Filiais',
          type: 'item',
          icon: '',
          url: '/filial',
        },
        {
          id: 'frases_padrao',
          title: 'Frase padrão',
          type: 'item',
          icon: '',
          url: '/frase-padrao',
        },
        {
          id: 'funcao_parceiro_de_negocio',
          title: 'Função Parceiros Negócio',
          type: 'item',
          icon: '',
          url: '/funcaoParceiro',
        },
        {
          id: 'composicao_veicular',
          title: 'Gestão da Composição',
          type: 'item',
          icon: '',
          url: '/composicoes-veiculares',
        },
        {
          id: 'incoterm',
          title: 'Incoterms',
          type: 'item',
          icon: '',
          url: '/incoterm',
        },
        {
          id: 'marcas_de_veiculos',
          title: 'Marcas de Veículos',
          type: 'item',
          icon: '',
          url: '/marcas-veiculos',
        },
        {
          id: 'modelos_de_veiculos',
          title: 'Modelos de Veículos',
          type: 'item',
          icon: '',
          url: '/modelos-veiculos',
        },
        {
          id: 'mercadoria',
          title: 'Mercadorias',
          type: 'item',
          icon: '',
          url: '/mercadoria',
        },
        {
          id: 'gestao_risco',
          title: 'Gestão de Risco',
          type: 'item',
          icon: '',
          url: '/gestao-risco',
        },
        {
          id: 'moedas',
          title: 'Moedas',
          type: 'item',
          icon: '',
          url: '/moeda',
        },
        {
          id: 'motivo',
          title: 'Motivo',
          type: 'item',
          icon: '',
          url: '/motivo',
        },

        {
          id: 'navio',
          title: 'Navio',
          type: 'item',
          icon: '',
          url: '/navio',
        },

        {
          id: 'network',
          title: 'Network',
          type: 'item',
          icon: '',
          url: '/network',
        },
        {
          id: 'origem/destino',
          title: 'Origem/Destino',
          type: 'item',
          icon: '',
          url: '/origemdestino',
        },
        {
          id: 'pais',
          title: 'País',
          type: 'item',
          icon: '',
          url: '/pais',
        },
        {
          id: 'parceiro_de_negocio',
          title: 'Parceiros de Negócio',
          type: 'item',
          icon: '',
          url: '/parceiro/parceiro-negocio',
        },

        {
          id: 'recinto_alfandegado',
          title: 'Recintos Alfandegados',
          type: 'item',
          icon: '',
          url: '/recinto-alfandegado',
        },

        {
          id: 'regra_de_calculo',
          title: 'Regras de Cálculo',
          type: 'item',
          icon: '',
          url: '/regraCalculo',
        },
        {
          id: 'tabela_piso_minimo_frete',
          title: 'Tabelas Piso Minimo Frete',
          type: 'item',
          icon: '',
          url: '/tabela-piso-minimo-frete'
        },
        {
          id: 'template_de_documento',
          title: 'Template Documento',
          type: 'item',
          icon: '',
          url: '/template-documento',
        },

        {
          id: 'tipo_container',
          title: 'Tipo Container',
          type: 'item',
          icon: '',
          url: '/tipocontainer',
        },

        {
          id: 'unidade_da_receita_federal',
          title: 'Unidades Receita Federal',
          type: 'item',
          icon: '',
          url: '/unidade-receita-federal',
        },
        {
          id: 'veiculo',
          title: 'Veículos',
          type: 'item',
          icon: '',
          url: '/veiculos',
        },
      ],
    },
    {
      id: 'comercial',
      title: 'Comercial',
      type: 'collapsible',
      icon: 'trending-up',
      children: [
        {
          id: 'crm',
          title: 'CRM',
          type: 'item',
          icon: '',
          url: '/parceiro/crm',
        },

        {
          id: 'oportunidade',
          title: 'Oportunidade',
          type: 'item',
          icon: '',
          url: '/oportunidadeOferta/list',
        },

        {
          id: 'oportunidade_tr',
          title: 'Oportunidade Rodoviário',
          type: 'item',
          icon: '',
          url: '/oportunidadeOfertaTr/list',
        },

        {
          id: 'farol_de_metas',
          title: 'Farol de Metas',
          type: 'item',
          icon: '',
          url: '/farolMetas',
        },
      ],
    },
    {
      id: 'configuracoes',
      title: 'Configurações',
      type: 'collapsible',
      icon: 'settings',
      children: [
        {
          id: 'agenda_automatica',
          title: 'Agenda Automática',
          type: 'item',
          icon: '',
          url: '/agenda-automatica',
        },
        {
          id: 'cargo',
          title: 'Cargos',
          type: 'item',
          icon: '',
          url: '/cargo',
        },
        {
          id: 'configuracoes_de_e-mail',
          title: 'Configurações de E-mail',
          type: 'item',
          icon: '',
          url: '/email-configuracoes',
        },
        {
          id: 'departamento',
          title: 'Departamentos',
          type: 'item',
          icon: '',
          url: '/departamento',
        },
        {
          id: 'schedule_jobs',
          title: 'Schedule Jobs',
          type: 'item',
          icon: '',
          url: '/schedule-jobs',
        },
        {
          id: 'grupos',
          title: 'Grupos',
          type: 'item',
          icon: '',
          url: '/grupo',
        },
        {
          id: 'metas',
          title: 'Metas',
          type: 'item',
          icon: '',
          url: '/meta',
        },
        {
          id: 'modelo_de_email',
          title: 'Modelos de E-mail',
          type: 'item',
          icon: '',
          url: '/modelo-email',
        },
        {
          id: 'query_dinamica',
          title: 'Query Dinâmica',
          type: 'item',
          icon: '',
          url: '/query-dinamica',
        },
        {
          id: 'parametros',
          title: 'Parâmetros',
          type: 'item',
          icon: '',
          url: '/parametro',
        },
        {
          id: 'roles',
          title: 'Perfis',
          type: 'item',
          icon: '',
          url: '/role',
        },
        {
          id: 'permissoes',
          title: 'Permissões',
          type: 'item',
          icon: '',
          url: '/permissao',
        },
        {
          id: 'recursos',
          title: 'Recursos',
          type: 'item',
          icon: '',
          url: '/recurso',
        },
        {
          id: 'arquivo_tipo_documento',
          title: 'Tipo Documento (Arquivo)',
          type: 'item',
          icon: '',
          url: '/arquivo-tipo-documento',
        },
        {
          id: 'usuarios',
          title: 'Usuários',
          type: 'item',
          icon: '',
          url: '/usuario',
        },
      ],
    },
    {
      id: 'financeiro',
      title: 'Financeiro',
      type: 'collapsible',
      icon: 'dollar-sign',
      children: [
        {
          id: 'contas_bancarias',
          title: 'Conta Bancária',
          type: 'item',
          icon: '',
          url: '/conta-bancaria',
        },
        {
          id: 'extrato_bancario',
          title: 'Extrato Bancário',
          type: 'item',
          icon: '',
          url: '/extrato-bancario',
        },
        {
          id: 'faturas',
          title: 'Faturas',
          type: 'item',
          icon: '',
          url: '/fatura',
        },
        {
          id: 'fatura_tr',
          title: 'Fatura Rodoviário',
          type: 'item',
          icon: '',
          url: '/faturaTr',
        },
      ],
    },

    {
      id: 'pricing',
      title: 'Pricing',
      type: 'collapsible',
      icon: 'shopping-bag',
      children: [
        {
          id: 'tabela_frete',
          title: 'Tabela Frete',
          type: 'item',
          icon: '',
          url: '/tarifario-tr',
        },
        {
          id: 'tarifario',
          title: 'Tarifário',
          type: 'item',
          icon: '',
          url: '/tarifario',
        },
        {
          id: 'tarifario_local',
          title: 'Tarifário Local',
          type: 'item',
          icon: '',
          url: '/tarifariolocal',
        },
        {
          id: 'tarifario_demurrage',
          title: 'Tarifário Demurrage',
          type: 'item',
          icon: '',
          url: '/tarifario-demurrage',
        },
      ],
    },

    {
      id: 'processos',
      title: 'Processo',
      type: 'collapsible',
      icon: 'trending-up',
      children: [
        {
          id: 'processo',
          title: 'Processo',
          type: 'item',
          icon: '',
          url: '/processo',
        },

        {
          id: 'processo_tr',
          title: 'Processo Rodoviário',
          type: 'item',
          icon: '',
          url: '/processoTr',
        },

        {
          id: 'controle_booking',
          title: 'Controle Booking',
          type: 'item',
          icon: '',
          url: '/controle-booking',
        },

        {
          id: 'devolucao_de_container',
          title: 'Devolução de Container',
          type: 'item',
          icon: '',
          url: '/devolucao-container',
        },
      ],
    },
    {
      id: 'relatorios',
      title: 'Relatórios',
      type: 'item',
      icon: 'bar-chart-2',
      url: '/relatorios',
    },
  ];
}
